const externalSubmit = (formRef) => {
  if (formRef.current === null) return;
  if (typeof formRef.current.requestSubmit === "function") {
    formRef.current.requestSubmit();
  } else {
    formRef.current.dispatchEvent(new Event("submit", { cancelable: true }));
  }
};

export default externalSubmit;
